import type { CognitiveReport } from './cognitiveEngine';

const REPORTS_KEY = 'drumhi:cognitive:reports';
const MAX_REPORTS = 30;

function reportKey(activityId: string, profileId: string) {
  return `drumhi:cognitive:${activityId}:${profileId}`;
}

export function readPreviousReport(activityId: string, profileId: string): CognitiveReport | null {
  try {
    const value = window.localStorage.getItem(reportKey(activityId, profileId));
    return value ? (JSON.parse(value) as CognitiveReport) : null;
  } catch {
    return null;
  }
}

export function readAllReports(): CognitiveReport[] {
  try {
    const reports = JSON.parse(window.localStorage.getItem(REPORTS_KEY) || '[]');
    return Array.isArray(reports) ? reports : [];
  } catch {
    return [];
  }
}

export function readFeedbackHistory(): string[] {
  return readAllReports().map((report) => report.feedback?.id).filter((id): id is string => Boolean(id));
}

export function saveCognitiveReport(report: CognitiveReport) {
  try {
    window.localStorage.setItem(reportKey(report.activityId, report.ageProfileId), JSON.stringify(report));
    const previous = readAllReports();
    const reports = [report, ...previous].slice(0, MAX_REPORTS);
    window.localStorage.setItem(REPORTS_KEY, JSON.stringify(reports));
  } catch {
    // localStorage may be unavailable (private browsing, quota) — reports simply won't persist.
  }
}
